import { styled } from '@mui/material/styles'
import { Button } from '@mui/material'
import { createWithLoadingButton } from '$common/buttons/with-loading-button'

// TODO it should be clear for color of button on hover
const StyledButton = styled(Button)(({ theme }) => ({
  backgroundColor: theme.palette.secondary500,
  color: theme.palette.white,
  '&:hover': {
    backgroundColor: theme.palette.secondary500,
  },
  '&.Mui-disabled': {
    backgroundColor: `${theme.palette.secondary50} !important`,
    color: theme.palette.secondary700,
  },
  '& .MuiButton-endIcon': {
    margin: 0,
    '& > svg': {
      fontSize: '24px',
    },
  },
}))

export const SecondaryButton = createWithLoadingButton(StyledButton)
